import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import 'bloko/blocks/column/column.less';

import { COLUMN_TAG_INVARIANTS } from 'bloko/common/constants/invariants';
import { componentInvariants } from 'bloko/common/helpers/customPropTypes';

import ColumnsRow from './ColumnsRow';
import ColumnsWrapper from './ColumnsWrapper';

export default function Column({ Element, children, xs, s, m, l, container, ...columnProps }) {
    return (
        <Element
            className={classnames('bloko-column', {
                'bloko-column_container': container,
                [`bloko-column_xs-${xs}`]: xs,
                [`bloko-column_s-${s}`]: s,
                [`bloko-column_m-${m}`]: m,
                [`bloko-column_l-${l}`]: l,
            })}
            {...columnProps}
        >
            {children}
        </Element>
    );
}

Column.propTypes = {
    /** Содержимое внутри строки */
    children: PropTypes.node,
    /** Задает нулевые отступы у блока и позволяет использовать блок как контейнер для других колонок */
    container: PropTypes.bool,
    /** Количество колонок при ширине страницы до 699px строка содержит содержит до 4 колонок,
     * которые тянутся по ширине*/
    xs: PropTypes.oneOf(['0', '1', '2', '3', '4']),
    /** Количество колонок при ширине страницы от 700 до 1019px строка содержит до 8 колонок */
    s: PropTypes.oneOf(['0', '1', '2', '3', '4', '5', '6', '7', '8']),
    /** Количество колонок при ширине от 1020px до 1339px строка содержит до 12 колонок */
    m: PropTypes.oneOf(['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12']),
    /** Количество колонок при ширине от 1340px содержит до 16 колонок */
    l: PropTypes.oneOf(['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16']),
    /** Кастомный компонент функция или [доступные теги](#invariants)*/
    Element: componentInvariants(COLUMN_TAG_INVARIANTS),
};

Column.defaultProps = {
    Element: 'div',
};

export { ColumnsRow, ColumnsWrapper };
